const routes = [
    {
      path: '/monitor/haccps/:startDate?/:endDate?',
      props: true,
      component: () => import('@/views/monitor/haccp/Events.vue')
    },
  ]
  
  export default routes
